export interface TabOption<T extends string> {
  value: T;
  label: string;
}

interface TabProps<T extends string> {
  tabs: TabOption<T>[];
  selectedTab: T;
  onTabChange: (tab: T) => void;
  className?: string;
}

const Tab = <T extends string>({
  tabs,
  selectedTab,
  onTabChange,
  className = '',
}: TabProps<T>) => {
  return (
    <div
      role="tablist"
      aria-label="Tabs"
      className={`flex w-full items-center gap-2 ${className}`}
    >
      {tabs.map((tab) => {
        const selected = tab.value === selectedTab;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onTabChange(tab.value)}
            className={`flex-1 cursor-pointer px-2.5 py-1.5 text-center text-base leading-6 transition-colors ${
              selected
                ? 'border-primary border-b-2 text-black'
                : 'text-secondary-text border-b-2 border-transparent'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default Tab;
